import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api, formatApiErrorDetail } from "@/lib/apiClient";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";

export default function Register() {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", confirm: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (form.password.length < 6) return setError("Şifre en az 6 karakter olmalı");
    if (form.password !== form.confirm) return setError("Şifreler eşleşmiyor");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/register", { name: form.name.trim(), email: form.email.trim(), password: form.password });
      setUser(data);
      navigate("/");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-6">
      <div className="w-full max-w-md rounded-2xl border border-border bg-card p-8">
        <div className="mb-8 flex items-center gap-3">
          <img src="/logo.png" alt="Fit House" className="h-14 w-14 object-contain" />
          <div>
            <p className="font-heading text-xl font-extrabold tracking-tight">Hesap Oluştur</p>
            <p className="text-xs uppercase tracking-widest text-muted-foreground">Fit House · Yönetim Paneli</p>
          </div>
        </div>
        <form onSubmit={submit} className="space-y-4" data-testid="register-form">
          <div>
            <Label htmlFor="name">Ad Soyad</Label>
            <Input id="name" data-testid="register-name" value={form.name} onChange={set("name")} required className="mt-1" />
          </div>
          <div>
            <Label htmlFor="email">E-posta</Label>
            <Input id="email" type="email" data-testid="register-email" value={form.email} onChange={set("email")} required className="mt-1" />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <Label htmlFor="password">Şifre</Label>
              <Input id="password" type="password" data-testid="register-password" value={form.password} onChange={set("password")} required className="mt-1" />
            </div>
            <div>
              <Label htmlFor="confirm">Şifre (Tekrar)</Label>
              <Input id="confirm" type="password" data-testid="register-confirm" value={form.confirm} onChange={set("confirm")} required className="mt-1" />
            </div>
          </div>
          {error && <p data-testid="register-error" className="rounded-lg bg-destructive/10 px-3 py-2 text-sm text-destructive">{error}</p>}
          <Button type="submit" data-testid="register-submit" disabled={loading} className="w-full font-semibold">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Kayıt Ol"}
          </Button>
        </form>
        <p className="mt-6 text-center text-xs text-muted-foreground">Yeni hesaplar <b>Distribütör</b> yetkisiyle açılır; Tab Team veya Admin yetkisini yöneticiniz verebilir.</p>
        <p className="mt-3 text-center text-sm">
          Zaten hesabınız var mı? <Link to="/login" data-testid="register-login-link" className="text-primary hover:underline">Giriş yapın</Link>
        </p>
      </div>
    </div>
  );
}
